import React, { createContext, useContext, useEffect, useState } from "react";

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  // Try to get saved theme from localStorage, default to "light"
  const [theme, setTheme] = useState(localStorage.getItem("theme") || "light");

  // Whenever theme changes, set the data-bs-theme attribute and update localStorage
  useEffect(() => {
    document.body.setAttribute("data-bs-theme", theme);
    localStorage.setItem("theme", theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme((prev) => (prev === "light" ? "dark" : "light"));
  };

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

// Custom hook for easy access in any component
export const useTheme = () => useContext(ThemeContext);
